module.exports = __webpack_public_path__ + "static/img/Bachelor_010361.933a674.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010361.jpg
// module id = 156
// module chunks = 0